<div style="border-radius: 4px; padding: 0; max-height: 50px; margin-right: 12px"
    [ngClass]="disableShadow ? '' : 'shadow'" [style.width]="width">
    <div class="one-row">
        @if (hasAccess && url) {
        <img (click)="showFile()" [src]="url" width="50" height="50" style="
                    width: 50px;
                    height: 50px;
                    object-fit: cover;
                    object-position: center;
                    display: block;
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                    cursor: pointer;
                " />
        } @else {
        <div style="
                    width: 50px;
                    height: 50px;
                    object-fit: cover;
                    object-position: center;
                    display: block;
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                ">
        </div>
        }
        <div style="width: calc(100% - 100px); padding-left: 12px">
            <p style="padding: 0; margin: 0"><strong>{{ isLoading ? 'Laden...' : cutFileNameLength(document?.name) }}</strong></p>
            <p style="padding: 0; margin: 0; color: var(--mat-sys-outline-variant)" (click)="showOcrText()">
                {{fileSize}}, {{document?.createdAt | date:'shortDate'}}</p>
        </div>
        <span class="spacer"></span>
        @if (hasAccess) {
        @if(isPdfOrImageOrText()){
        <button mat-icon-button (click)="showFile()" [disabled]="!document" matTooltip="Ansehen">
            <mat-icon>visibility</mat-icon>
        </button>
        }
        <button mat-icon-button style="margin-top: 2px" (click)="document ? downloadFile() : null"
            [disabled]="!document" aria-label="Download" matTooltip="Download">
            <mat-icon>download</mat-icon>
        </button>
        }
    </div>
</div>